let tabs = document.querySelectorAll(".tab");
let tabContents = document.querySelectorAll(".tab-content");
tabs.forEach(function (tab) {
  tab.addEventListener("click", function () {
    let contentId = this.dataset.contentId;
    let content = document.getElementById(contentId);

    tabContents.forEach(function (content) {
      content.classList.remove("active");
    });

    tabs.forEach(function (tab) {
      tab.classList.remove("active");
    });

    this.classList.add("active");
    content.classList.add("active");
  });
});

//===== Hides Tabs when Tabbed-Description is used (ApsWithTable_) =======//
function hasSpecTab(tagString) {
  if (tagString.includes("ApsWithTable_")) {
    return tagString;
  }
}
function hasDocsTab(tagString) {
  if (tagString.includes("Brochure_") || tagString.includes("Manual_")) {
    return tagString;
  }
}
specTabArray = tagArray.filter(hasSpecTab);
docsTAbArray = tagArray.filter(hasDocsTab);
if (specTabArray[0]) {
  tabs.forEach(function (tab) {
    tab.style.display = "none";
  });
}
if (docsTAbArray.length == 0) {
  document.querySelector('[data-content-id="tab-content-3"]').style.display =
    "none";
}
